// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__m6BqV","active":"breadcrumb_active__m6BqV"};